
import './App.css';
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import { Home } from './components/Home/Home';
import { NavBar } from './components/NavBar/NavBar';
import { RecruiterContainer } from './components/RecruiterContainer/RecruiterContainer';
import { MyStudiesCards } from './components/MyStudiesCards/MyStudiesCards'
import { AboutContainer } from './components/AboutContainer/AboutContainer'
import { ProjectsCards } from './components/ProjectsCards/ProjectsCards';
import { MyExperiencesCards } from './components/MyExperiencesCards/MyExperiencesCards';
import { SkillsCards } from './components/SkillsCards/SkillsCards';
import { Cv } from './components/Cv/Cv';
function App() {

  
  return (
    <>
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/recruiter' element={<RecruiterContainer />} />
        <Route path='/recruiter/studies' element={<MyStudiesCards />}/>
        <Route path='/recruiter/experiences' element={<MyExperiencesCards />}/>
        <Route path='/recruiter/skills' element={<SkillsCards/>}/>
        <Route path='/recruiter/about' element={<AboutContainer/>}/>
        <Route path='/recruiter/projects' element={<ProjectsCards />}/>
        <Route path='/cv' element={<Cv/>}/>
      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
